import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUp, FileText, Headphones, Phone } from 'lucide-react';

export const PlatformFloatingRail: React.FC<{
  hideUntilPastHero?: boolean;
}> = ({ hideUntilPastHero = false }) => {
  const [pastHero, setPastHero] = useState(!hideUntilPastHero);

  useEffect(() => {
    if (!hideUntilPastHero) return undefined;

    const hero = document.querySelector('.solution-page > .solution-hero, .iot-cloud-hero');
    if (!hero) {
      setPastHero(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setPastHero(!entry.isIntersecting);
      },
      { threshold: 0 },
    );

    observer.observe(hero);
    return () => observer.disconnect();
  }, [hideUntilPastHero]);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const isHidden = hideUntilPastHero && !pastHero;

  return (
    <aside
      className={`platform-sub-rail${isHidden ? ' platform-sub-rail--below-hero' : ' platform-sub-rail--visible'}`}
      aria-label="Quick actions"
      aria-hidden={isHidden}
    >
      <Link to="/contact-us" className="platform-sub-rail__btn" aria-label="Support" tabIndex={isHidden ? -1 : undefined}>
        <Headphones size={20} strokeWidth={1.75} />
      </Link>
      <Link to="/contact-us" className="platform-sub-rail__btn" aria-label="Contact" tabIndex={isHidden ? -1 : undefined}>
        <Phone size={20} strokeWidth={1.75} />
      </Link>
      <Link to="/developer-guide" className="platform-sub-rail__btn" aria-label="Documentation" tabIndex={isHidden ? -1 : undefined}>
        <FileText size={20} strokeWidth={1.75} />
      </Link>
      <button
        type="button"
        className="platform-sub-rail__btn"
        onClick={scrollTop}
        aria-label="Back to top"
        tabIndex={isHidden ? -1 : undefined}
      >
        <ArrowUp size={20} strokeWidth={1.75} />
      </button>
    </aside>
  );
};
